<template>
  <div id="order-label-print">
    <div v-for="(product, index) in selected" :key="product.id || product.sku || index" class="barcode-label">
      <svg class="barcode" jsbarcode-displayvalue="true" jsbarcode-format="code128" :jsbarcode-value="product.sku" jsbarcode-height="92" jsbarcode-width="2"></svg>
    </div>
  </div>
</template>

<script>
export default {
  props: ['selected'],
  data () {
    return {}
  }
}
</script>

<style lang="scss">
@media print{
  @page {
    size: 3.5cm 2.5cm;
    margin: 0;
  }
  html,
  body {
    width: 3.5cm;
    height: 2.5cm;
    margin: 0;
  }
  #shipblu-chat-launcher,
  #shipblu-chat-frame,
  #fc_frame {
    display: none;
  }
  .shipment-page,
  .dropdown-menu{
    *{
      visibility: hidden;
      color: black;
    }
    #order-label-print,
    #order-label-print *{
      visibility: visible;
    }
    #order-label-print{
      display: block;
    }
    #content-area {
      margin: 0 !important;
    }
    #order-label-print {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
    .barcode-label {
      width: 3.5cm;
      height: 2.5cm;
      margin: 0 !important;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      page-break-before: auto;
      page-break-after: always;
      page-break-inside: avoid;
      break-before: auto;
      break-after: page;
      break-inside: avoid;
      box-sizing: border-box;
    }
    .barcode-label:last-child {
      page-break-after: auto;
      break-after: auto;
    }
    .barcode-label .barcode {
      max-width: 3.3cm;
      max-height: 2.3cm;
    }
  }
}
</style>
